// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  bottom: 0px;
  background-color: #fff;
  position: fixed !important;
  width: 100%;
  height: 10vh;
  margin-left: -15px;
  box-shadow: 0 1px 4px 0 rgba(0,0,0,.3);
}

@media screen and (max-width: 576px) {
  .footer {
    margin-left: -8px;
  }
}

@media screen and (min-width: 577px) and (max-width: 768px) {
  .footer {
    margin-left: -8px;
  }
}

@media screen and (min-width: 769px) and (max-width: 1280px) {
  .footer {
    margin-left: -16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/shared/component/footer/footer.component.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,sBAAsB;EACtB,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".footer {\n  bottom: 0px;\n  background-color: #fff;\n  position: fixed !important;\n  width: 100%;\n  height: 10vh;\n  margin-left: -15px;\n  box-shadow: 0 1px 4px 0 rgba(0,0,0,.3);\n}\n\n@media screen and (max-width: 576px) {\n  .footer {\n    margin-left: -8px;\n  }\n}\n\n@media screen and (min-width: 577px) and (max-width: 768px) {\n  .footer {\n    margin-left: -8px;\n  }\n}\n\n@media screen and (min-width: 769px) and (max-width: 1280px) {\n  .footer {\n    margin-left: -16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
